import { sortingList } from '../../../utils/helper'
import { DataItem } from './types'

export const sortingActivityList = (
  list: DataItem[],
  type: string,
  name: string | undefined
): DataItem[] => {
  try {
    let newList: DataItem[] = list
    switch (name) {
      case 'InspectionScore':
      case 'CheckNumber':
      case 'NumOfReturnDate':
        newList = sortingList(list, type, name, 'number')
        break
      case 'InspectDate':
        newList = sortingList(list, type, name, 'date')
        break

      default:
        newList = sortingList(list, type, name || '', 'string')
    }

    return newList
  } catch (e) {
    return list
  }
}
